<div class="twc-d-flex align-center">
    <div *ngIf="!showInputs" class="circle" [ngClass]="{'read-only': readonly || disabled}"
        [ngStyle]="{'background-color': getStrColor()}" (click)="overlayClick()">
    </div>
    <div class="twc-body" [ngClass]="{'labelWithoutInputs twc-mt-3': !showInputs, 'twc-pl-3': showInputs}"
        *ngIf="label">
        {{label | translate}}
    </div>
</div>

<div class="colorPickerStyle" *ngIf="showInputs">
    <cw-input-color *ngFor="let colorValue of listRGB" [tag]="colorValue.tagValue" [value]="colorValue.value"
        [disabled]="disabled" [readonly]="readonly" (changeValue)="setComponentValue($event)">
    </cw-input-color>
    <div class="circle" [ngClass]="{'read-only': readonly || disabled}" [ngStyle]="{'background-color': getStrColor()}"
        (click)="overlayClick()"></div>
</div>